// ExpenseItem Component

/* eslint indent: 0, react/jsx-indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import DateUtil from '../../../lib/dateutil.jsx'
import Avatar from '../../../common/common/avatar/avatar.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'

class ExpenseItem extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bShowItems: false
    }
  }

  static get propTypes () {
    return {
      expense: PropTypes.object,
      onSetting: PropTypes.func,
      onView: PropTypes.func,
      onSubView: PropTypes.func,
      isQuickbookConnected: PropTypes.bool,
      useProjectNumber: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      expense: null,
      onSetting: null,
      onView: null,
      onSubView: null,
      isQuickbookConnected: false,
      useProjectNumber: false
    }
  }

  render () {
    const expense = this.props.expense
    const date = new Date(expense.invoiceDate)
    const currDate = DateUtil.getUTCCurrentDate()
    const todayDate = new Date(
      currDate.getFullYear(),
      currDate.getMonth(),
      currDate.getDate()
    )
    const bOverDue = date.getTime() < todayDate.getTime()

    let noItems = 0
    if (expense.items && expense.items.length > 0) {
      noItems = expense.items.length
    }

    const _className = classnames('expense-item', {
      expanded: this.state.bShowItems,
      expense_item_closed: bOverDue,
      overbudget: this._checkItemsForOverBudget()
    })
    const _classDate = bOverDue === 'closed' ? 'coldate year' : 'coldate'

    return (
      <div className={_className} onClick={this._onView.bind(this)}>
        <div className={_classDate}>
          <div className='month'>{DateUtil.getDisplayMonth(date)}</div>
          <div className='day'>{DateUtil.getDisplayDay(date)}</div>
          <div className='year'>{DateUtil.getDisplayYear(date)}</div>
        </div>
        <div className='colsplit' />
        <div className='colinner'>
          <h4 className='title'>
            {expense.contact ? expense.contact.company : ''}
          </h4>
          {expense.description && (
            <IconButton
              icon='list-notify'
              size='normal'
              canHover={false}
              className='subcriptioninfo'
              multilingual={false}
              tooltip={expense.description}
              tooltipPosition='top'
            />
          )}
          <div className='info'>
            {expense.attachment && (
              <IconButton
                icon='list-attachment'
                size='normal'
                canHover
                className='subcriptioninfo'
                tooltip='expense.list.tipAttachment'
                tooltipPosition='top'
                href={encodeURI(
                  `/expense/preview/${expense.teamId}/${expense.attachment.fileName}/${expense.attachment.name}`
                )}
                target='_blank'
                onClick={this._onClickDownload.bind(this)}
              />
            )}
            <div className='value'>{expense.invoiceNo}</div>
            {noItems > 0 && <div className='split' />}
            {noItems > 0 && (
              <div
                className='item-cont'
                onClick={this._onClickExpand.bind(this)}
              >
                <span className='item'>
                  {noItems}
                  <IntlMessage ident='expense.form.labelItems' />
                </span>
                <span className='iconcont'>
                  <i className='icon icon-grid-expand normal' />
                  <i className='icon icon-grid-expand-hover hover' />
                </span>
              </div>
            )}
          </div>
        </div>
        <div className='colavatar'>
          {expense.contact && expense.contact.imageUrl && (
            <Avatar
              imageUrl={expense.contact.imageUrl}
              title={expense.contact.company}
            />
          )}
        </div>
        <div className='colsplit' />
        <div className='coltotal'>
          {this.props.isQuickbookConnected &&
            expense.quickbook &&
            expense.quickbook.status === 'Error' && (
              <IconButton
                icon='dialog-warning'
                size='big'
                canHover={false}
                type='error'
                tooltip={expense.quickbook.message}
                tooltipPosition='bottom'
                className='errorinfo'
              />
            )}
          <div className='amount'>
            <span className='value'>
              <PriceText value={expense.total} />
            </span>
          </div>
        </div>
        {this.state.bShowItems && noItems > 0 && (
          <div className='projectitem'>
            <div className='itemhead'>
              <div className='itemcol'>
                <IntlMessage ident='expense.list.labelActivity' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='expense.list.labelProject' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='expense.list.labelClient' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='expense.list.labelPo' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='expense.list.labelBudget' />
              </div>
              <div className='itemcol'>
                <IntlMessage ident='expense.list.labelSpent' />
              </div>
            </div>
            {this._renderSubItems(expense)}
          </div>
        )}
        <IconButton
          title='expense.list.titleSettings'
          icon='common-action-setting'
          size='small'
          onClick={this._onSetting.bind(this)}
        />
      </div>
    )
  }

  /* Event handlers */
  _onView (e) {
    e.preventDefault()

    if (this.props.onView) {
      this.props.onView(this.props.expense)
    }
  }

  _onSetting (e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onSetting) {
      this.props.onSetting(this.props.expense)
    }
  }

  _onClickDownload (ev) {
    ev.stopPropagation()
  }

  _onClickExpand (e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ bShowItems: !this.state.bShowItems })
  }

  _onClickSubItem (item, e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.props.onSubView) {
      this.props.onSubView(item.projectId)
    }
  }

  /* Private Functions */
  // If any one expense item has spent amount greater than budget amount expense should be in red
  _checkItemsForOverBudget () {
    const expense = this.props.expense
    const overBudgetItem = _.find(
      expense.items,
      item => item.budgetitem && item.budgetitem.total < item.total
    )

    return overBudgetItem !== null && overBudgetItem !== undefined
  }

  _renderSubItems (expense) {
    return expense.items.map((item, idx) => {
      if (item.budgetitem) {
        return this._renderEstimateBudgetSubItem(item, idx)
      } else {
        return this._renderEstimateSubItem(item, idx)
      }
    })
  }

  _renderEstimateBudgetSubItem (item, idx) {
    let purchaseOrder = null
    if (item.budgetItemSupplier && item.budgetItemSupplier.purchaseOrder) {
      purchaseOrder = item.budgetItemSupplier.purchaseOrder
    }

    const itemClassName = classnames('itemcol', {
      overbudget: item.budgetitem.total < item.total
    })

    return (
      <div
        className='itemrow'
        key={idx}
        onClick={this._onClickSubItem.bind(this, item)}
      >
        <div className='itemcol'>{item.budgetitem.title}</div>
        <div className='itemcol'>
          {[
            this.props.useProjectNumber && item.project.projectNumber,
            item.project.title
          ]
            .filter(Boolean)
            .join(' / ')}
        </div>
        <div className='itemcol'>{item.contact.company}</div>
        <div className='itemcol'>
          {purchaseOrder ? purchaseOrder.invoiceNo : '-'}
        </div>
        <div className='itemcol'>
          <PriceText value={item.budgetitem.total} />
        </div>
        <div className={itemClassName}>
          <PriceText value={item.total} />
        </div>
      </div>
    )
  }

  _renderEstimateSubItem (item, idx) {
    return (
      <div
        className='itemrow'
        key={idx}
        onClick={this._onClickSubItem.bind(this, item)}
      >
        <div className='itemcol'>-</div>
        <div className='itemcol'>
          {[
            this.props.useProjectNumber && item.project.projectNumber,
            item.project.title
          ]
            .filter(Boolean)
            .join(' | ')}
        </div>
        <div className='itemcol'>{item.contact.company}</div>
        <div className='itemcol'>
          {item.purchaseOrderId ? item.purchaseOrderId : '-'}
        </div>
        <div className='itemcol'>
          <PriceText value='' />
        </div>
        <div className='itemcol'>
          <PriceText value={item.total} />
        </div>
      </div>
    )
  }
}

export default ExpenseItem
